import { getSharedViewId } from '../routing/utils';
import { ThemeManager } from '../themes/theme-manager';

export const useSharedView = () => {
  const sharedViewId = getSharedViewId();
  const isSharedView = ThemeManager.instance.isSharedView;

  return {
    isSharedView,
    sharedViewId,
  };
};
